export default "__VITE_ASSET__ee2f1367__"